import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import "./index.css";
import { hindiPoints, points } from "./cityData.js";
import { FC } from "react";

interface KeyPointsProfessionalProps {
  selected: any;
}

const KeyPointsProffesional: FC<KeyPointsProfessionalProps> = ({
  selected,
}) => {
  const point = selected ? points : hindiPoints;

  return (
    <Grid container spacing={2}>
      {point.map((point, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Box
            sx={{
              background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
              marginBottom: 0,
              borderRadius: "16px",
              padding: { xs: "1.25rem", sm: "1.5rem" },
              color: "#fff",
              height: "100%",
              border: "1px solid rgba(255,255,255,0.12)",
              boxShadow: "0 12px 36px rgba(18, 53, 36, 0.2)",
            }}
          >
            <Typography
              variant="h5"
              component="h3"
              sx={{
                fontWeight: 700,
                py: 0.5,
                color: "#fff",
                fontSize: { xs: "1.1rem", sm: "1.35rem" },
              }}
            >
              {point.title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: "rgba(255,255,255,0.95)", lineHeight: 1.65 }}
            >
              {point.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default KeyPointsProffesional;
